module.exports = __webpack_public_path__ + "assets/img/driver-btn-87a0532a.png";